import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMobilePhoneMask]',
})
export class MobilePhoneMaskDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    if (value.length > 6) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(
        2,
        7
      )}-${value.substring(7)}`;
    } else if (value.length > 2) {
      input.value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
    } else {
      input.value = value;
    }

    this.ngControl.control?.setValue(input.value);
  }
}
